module.exports = __webpack_public_path__ + "static/media/banner_5.4bfeea64.jpg";